import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

/**
 * What the browser does for free on a multi-page site and not at all in a
 * single-page one:
 *
 *   - a new page starts at the top rather than halfway down, wherever the
 *     previous page happened to be scrolled to;
 *   - a link carrying a hash (`/#admissions` from the footer) scrolls to that
 *     section once the destination page has actually rendered.
 *
 * Only PUSH navigations are moved. Back, forward and a plain reload all arrive
 * as POP, and the browser restores the previous scroll position for those
 * itself — jumping those to the top is what makes single-page history feel
 * broken.
 */
export default function ScrollManager() {
  const { pathname, hash, key } = useLocation();
  const navigationType = useNavigationType();

  useEffect(() => {
    if (hash) {
      const target = document.querySelector(hash);
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
    }

    if (navigationType === 'PUSH') window.scrollTo({ top: 0, behavior: 'auto' });
    // `key` changes on every navigation, so clicking the link for the page you
    // are already on still takes you back to the top.
  }, [pathname, hash, key, navigationType]);

  return null;
}
